var map = {
	"./Logout.vue": [
		444,
		19
	],
	"./errors/404.vue": [
		445,
		18
	],
	"./patient/Bonuses/Index.vue": [
		446,
		7
	],
	"./patient/Bonuses/Register.vue": [
		447,
		0
	],
	"./patient/Bonuses/partials/One.vue": [
		439,
		14
	],
	"./patient/Bonuses/partials/Three.vue": [
		440,
		17
	],
	"./patient/Bonuses/partials/Two.vue": [
		441,
		13
	],
	"./patient/Dashboard.vue": [
		448,
		20
	],
	"./patient/InfoPanel/Appointments.vue": [
		449,
		6
	],
	"./patient/InfoPanel/Info.vue": [
		450,
		9
	],
	"./patient/InfoPanel/Reserves.vue": [
		451,
		5
	],
	"./patient/ProfilePatient.vue": [
		452,
		11
	],
	"./patient/Underlying/Index.vue": [
		453,
		4
	],
	"./patient/partials/Layout.vue": [
		454,
		1
	],
	"./patient/partials/Navbar.vue": [
		442,
		16
	],
	"./patient/partials/Sidebar.vue": [
		443,
		15
	],
	"./public/---RegisterPatient.vue": [
		455,
		8
	],
	"./public/LoginPatient.vue": [
		456,
		12
	],
	"./public/Prefix.vue": [
		457,
		10
	],
	"./public/Recovery.vue": [
		458,
		2
	],
	"./public/RegisterPatient.vue": [
		459,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 436;


//////////////////
// WEBPACK FOOTER
// ./src/components lazy ^\.\/.*\.vue$
// module id = 436
// module chunks = 22